import { render, staticRenderFns } from "./ResidentsLifestyleEventsReport.vue?vue&type=template&id=5fc0ee48&scoped=true"
import script from "./ResidentsLifestyleEventsReport.ts?vue&type=script&lang=ts&external"
export * from "./ResidentsLifestyleEventsReport.ts?vue&type=script&lang=ts&external"
import style0 from "./ResidentsLifestyleEventsReport.scss?vue&type=style&index=0&id=5fc0ee48&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0ee48",
  null
  
)

export default component.exports